









import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class TextareaCodeEditor extends Vue {
  @Prop() private func!: string;
  @Prop({ default: '70vh' }) private editorHeight!: string;

  private mounted() {
    const code = this.$refs.code as any;
    const displayed = this.$refs.displayed as any;
    const typed = this.$refs.typed as any;

    code.innerHTML = typed.innerHTML = this.func;
    displayed.style.height = typed.style.height = this.editorHeight;
  }

  private updateMappingFunction(e: any) {
    const el = this.$refs.code as any;

    if (e.target.value[e.target.value.length - 1] === '\n') {
      e.target.value += '';
    }
    el.innerHTML = e.target.value.replace(new RegExp('&', 'g'), '&amp;').replace(new RegExp('<', 'g'), '&lt;');

    this.$emit('updateFunction', e.target.value);
  }

  private checkTab(e: any) {
    if (e.key === 'Tab') {
      e.preventDefault();
      const start = e.target.selectionStart;
      const end = e.target.selectionEnd;

      e.target.value = e.target.value.substring(0, start) + '\t' + e.target.value.substring(end);
      e.target.selectionStart = e.target.selectionEnd = start + 1;
    }
  }

  private syncScroll(e: any) {
    const displayed = this.$refs.displayed as any;
    displayed.scrollTop = e.target.scrollTop;
    displayed.scrollLeft = e.target.scrollLeft;
  }
}
